import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { NgZorroAntdModule, NZ_I18N, ar_EG } from 'ng-zorro-antd';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { registerLocaleData } from '@angular/common';
import ar from '@angular/common/locales/ar';

registerLocaleData(ar);

import { FormComponent } from './components/form/form.component';
import { AngularFireModule } from '@angular/fire';
import { AngularFirestoreModule } from '@angular/fire/firestore';
import { AngularFireStorageModule } from '@angular/fire/storage';
import { environment } from '../environments/environment';
import { SuccessComponent } from './components/success/success.component';
import { FormService } from './services/form.service';
import { VideoPreviewComponent } from './components/video-preview/video-preview.component';
import { FormChoiceComponent } from './components/form-choice/form-choice.component';
import { FormPressComponent } from './components/form-press/form-press.component';
import { FormPhotoComponent } from './components/form-photo/form-photo.component';

@NgModule({
  declarations: [
    AppComponent,
    FormComponent,
    SuccessComponent,
    VideoPreviewComponent,
    FormChoiceComponent,
    FormPressComponent,
    FormPhotoComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    NgZorroAntdModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    BrowserAnimationsModule,
    AngularFireModule.initializeApp(environment.firebase),
    AngularFirestoreModule,
    AngularFireStorageModule
  ],
  providers: [
    { provide: NZ_I18N, useValue: ar_EG },
    FormService
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
